import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import AppBar from "material-ui/AppBar";
import Typography from "material-ui/Typography";
import Button from "../../../Parts/Button";
import CompleteCircle from "../../../Icons/CompleteCircle";
import { SalesforceImportStep } from "../../../../constants/ComponentTypes";
import arrow from "../../../../assets/icons/arrow-left.svg";

const styles = () => ({
  root: {
    width: "100%",
    height: "76px",
    boxShadow: "0px -1px 3px #00000029",
    transition:
      "transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)",
  },

  appBar: {
    color: "#181819",
    background: "#FFFFFF",
    padding: "15px 25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row",
  },

  flex: {
    flex: 1,
  },

  labels: {
    display: "flex",
    alignItems: "center",
  },

  labelContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "20px",
  },

  label: {
    fontSize: "13px",
    fontWeight: "bold",
    color: "#B1B3B9",
    marginLeft: "6px",
  },
});

class BottomMenu extends React.Component {
  isEmpty = (fields) => {
    const { mapping } = this.props;
    let res = true;
    fields.forEach((field) => {
      if (mapping.get(field) && mapping.get(field).count() > 0) {
        res = false;
      }
    });
    return res;
  };

  disableBtn = () => {
    let res = false;
    this.props.requiredFields.forEach((field) => {
      res = res || this.isEmpty(field.key);
    });

    res =
      res ||
      (this.props.step === SalesforceImportStep.PREVIEW &&
        this.props.loadingPreviewFailed);
    return res;
  };

  render() {
    const { classes, open } = this.props;

    return (
      <div
        className={classes.root}
        style={{
          transform: open ? "translateY(0%)" : "translateY(100%)",
          visibility: open ? "visible" : "hidden",
        }}
      >
        <AppBar position="static" color="default" className={classes.appBar}>
          <Button
            text="戻る"
            size="large"
            type="line"
            icon={arrow}
            handleClickButton={this.props.prev}
          />
          <div className={classes.flex}></div>
          {this.props.step === SalesforceImportStep.MAPPING && (
            <div className={classes.labels}>
              {this.props.requiredFields.map((field, i) => {
                const selected = !this.isEmpty(field.key);
                return (
                  <div key={i} className={classes.labelContainer}>
                    <CompleteCircle
                      width={14}
                      height={14}
                      color={selected ? "#5593FF" : "#B1B3B9"}
                      style={{ display: "block" }}
                    />
                    <Typography
                      variant="body2"
                      className={classes.label}
                      style={{ color: selected ? "#5593FF" : "#B1B3B9" }}
                    >
                      {field.text}
                    </Typography>
                  </div>
                );
              })}
            </div>
          )}
          <Button
            text={
              this.props.step === SalesforceImportStep.MAPPING
                ? "次へ"
                : "設定を保存"
            }
            size="large"
            loading={
              this.props.step === SalesforceImportStep.MAPPING
                ? this.props.isLoadingPreview
                : this.props.isConfiguring
            }
            disabled={this.disableBtn()}
            handleClickButton={this.props.next}
          />
        </AppBar>
      </div>
    );
  }
}

BottomMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number,
  open: PropTypes.bool,
  step: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  isLoadingPreview: PropTypes.bool,
  isConfiguring: PropTypes.bool,
  loadingPreviewFailed: PropTypes.bool,
  requiredFields: PropTypes.array,
  mapping: PropTypes.object,
  prev: PropTypes.func,
  next: PropTypes.func,
};

export default withStyles(styles)(BottomMenu);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceAddressSetting/BottomMenu.jsx